<template>
<div class="component">

    <div class="wwfooter ">

        <div class="footerImages columns is-mobile is-multiline">
            <div class="column is-6-widescreen is-6-tablet is-12-mobile is-mobile">
                <div class="footerImageLeft columns is-mobile is-multiline">

                    <div class="column is-mobile is-6 footerImage"><img src="@/assets/zim.jpg" /></div>
                    <div class="column is-mobile is-6 footerImage"><img src="@/assets/coldewey.png" /></div>

                    <div class="column is-mobile is-6 footerImage"><img src="@/assets/qf.png" /></div>
                    <div class="column is-mobile is-6 footerImage"><img src="@/assets/biba.png" /></div>
                </div>
            </div>
            <div class="column wwBackground is-6-widescreen is-6-tablet is-12-mobile is-mobile">
                <div class="wwTitleSize bauen40">Projekt aus Bauen 4.0 Netzwerk
                </div>
                <div class="bauenimage"><img src="@/assets/bauen40.jpg" /></div><br/>
                <div class ="title has-text-white">Förderkennzeichen: 03SBE111L</div>
            </div>
        </div>
    </div>
</div>

</div>
</div>
</template>

<script>
export default {
    name: 'component',
    props: [],
    mounted: function () {},
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: []
        }
    },
    methods: {},
    computed: {},
}
</script>

<style scoped>
.wwfooter {
    margin-top: 5vh;
    min-height: 10vh;
    border:15px solid #2147A2;
}



.bauen40 {
    color: white;
}
</style>
